/**
 * MyWorkLink -- My Work in the masthead, with its count.
 *
 * P268.2 put it beside the bell as a glyph. The stitching review
 * (2026-10-02, docs/the-story.md) moved it into the navigation, first:
 * "What must I do?" is the one question every seat shares, My Work is
 * the surface that answers it, and the walks praised it every round
 * while it sat in no navigation strip. Polls via the shared
 * `useMyWork` (60s) so the badge tracks the bell's cadence.
 */
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { MarsadIcon } from "shared/components/MarsadIcon";
import { useMyWork } from "shared/work/useMyWork";

export function MyWorkLink({
  className,
}: {
  className: string | ((p: { isActive: boolean }) => string);
}) {
  const { t } = useTranslation();
  const work = useMyWork();
  // B4 -- count only what is being asked of this person. The badge
  // read 5 or 7 against one real ask, because it counted everything
  // reachable through a shared queue as well.
  const total = work.data?.needs_you ?? 0;

  return (
    <NavLink to="/my-work" data-testid="my-work-link" className={className} end>
      <MarsadIcon name="dual-signoff" size={15} />
      {t("nav.myWork")}
      {total > 0 && (
        <span
          data-testid="my-work-badge"
          className="ms-1 min-w-[15px] h-[15px] rounded-full bg-brand-brass px-1 text-center font-mono text-[9px] font-bold leading-[15px] text-[#1d1607]"
        >
          {total > 99 ? "99+" : total}
        </span>
      )}
    </NavLink>
  );
}
